import { announcementCenter } from '@/apis/18726'
import { message } from 'ant-design-vue'
export default {
  state: {
    noticeCount: 0
  },
  mutations: {
    async GET_NOTICE_COUNT(state) {
      const token = localStorage.getItem('token')
      if (!token) return

      let vuex = {}
      if (localStorage.getItem('vuex')) {
        vuex = JSON.parse(localStorage.getItem('vuex'))
      }

      const {
        success,
        retInfo,
        data
      } = await announcementCenter.unread_count_post({
        responsibleId: vuex?.user?.userInfo?.userId,
        scopeType: 1
      })
      if (success) {
        state.noticeCount = data?.totalUnreadCount
      } else {
        message.error(retInfo)
      }
    }
  },
  actions: {}
}
